import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const loginAPI = async ({subsidiaryId, email, password}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);

    const URL = `${BASE_URL}/${requestSubsidiaryId}/public/client/login`
    const METHOD = "POST"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    console.log("POST Login")

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
        body: JSON.stringify({
            username: email,
            password
        })
    })

    if (!response.ok) {
        console.log("POST LOGIN ERROR")
        throw new Error(`HTTP error: ${response.status}`)
    }

    return await response.json()
}

export {loginAPI}
